import { type ReactNode } from 'react';
import cn from 'classnames';
import { HeaderCell, type HelpProps } from '@direct-frontend/components';
import { type ColumnHeaderTemplateProps } from '@adv-frontend/grid';
import { getHeaderCellSortingHandler } from '../../lib/getHeaderCellSortingHandler';
import { type BaseRowData, type GridRow } from '../../lib/types';
import styles from './CellHeader.module.css';

export function renderHeaderCell<RowData extends BaseRowData = GridRow>({
    leftPadding = true,
    dataTestId,
    exactDataTestId,
    align,
    title,
    help,
    className,
    firstSortDirection = 'asc',
}: {
    leftPadding?: boolean;
    dataTestId: string;
    exactDataTestId?: string;
    align?: 'left' | 'right' | 'center';
    title: string;
    help?: (helpProps: HelpProps) => ReactNode;
    className?: string;
    firstSortDirection?: 'asc' | 'desc';
}) {
    return function renderHeaderCell(props: ColumnHeaderTemplateProps<RowData>) {
        const { column } = props;

        return (
            <HeaderCell
                help={help}
                className={cn(styles.cell, className)}
                leftPadding={leftPadding}
                firstSortDirection={firstSortDirection}
                sortDirection={column.getCanSort() ? (column.getIsSorted() ?? false) : undefined}
                onSort={column.getCanSort() ? getHeaderCellSortingHandler(props) : undefined}
                data-testid={exactDataTestId ?? `${dataTestId}.Column.${column.id}`}
                title={title}
                isTitleTruncated
                align={align}
            />
        );
    };
}
